import { render, staticRenderFns } from "./AppConfirma.vue?vue&type=template&id=6bb53c66&"
import script from "./AppConfirma.vue?vue&type=script&lang=js&"
export * from "./AppConfirma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports